module.exports = {"locales":{"available":{"nl-NL":"Dutch","en-US":"English (US)","en-UK":"English (UK)"}}}